import React from 'react'

import PageWrapper from 'components/misc/PageWrapper'
import CardBanner from 'components/misc/CardBanner'

import styles from './500.module.scss'

const ErrorPage = (_props: any) => {
  return (
    <PageWrapper title="Data fetching error - Archidekt" robots="noindex">
      <CardBanner
        height="300px"
        artist
        src={'https://cards.scryfall.io/art_crop/front/4/a/4a4764da-c508-4a7e-aabc-771f22a32c23.jpg?1673914627'}
        title="Data fetching error"
      />
      <div className={styles.content}>An error happened while fetching data from our API</div>
    </PageWrapper>
  )
}

export default ErrorPage
